module.exports = "/_next/static/images/macpunk-footer-9d89ea0e5bb4f306606e9cd9470e1180.jpg";